(() => {
  const initTabs = (root = document) => {
    root.querySelectorAll('[data-vv-routine]').forEach((section) => {
      if (section.dataset.vvReady === 'true') return;
      section.dataset.vvReady = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-vv-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-vv-panel]'));

      const activate = (id, focus = false) => {
        const panel = panels.find((item) => item.dataset.vvPanel === id);
        const tab = tabs.find((item) => item.dataset.vvTab === id);
        if (!panel || !tab) return;

        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((item) => { item.hidden = item !== panel; });
        section.style.setProperty('--vv-active', panel.dataset.vvColor || '#e9581f');
        section.style.setProperty('--vv-active-ink', panel.dataset.vvInk || '#ffffff');
        if (focus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.vvTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next].dataset.vvTab, true);
        });
      });

      const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      if (selected) activate(selected.dataset.vvTab);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTabs());
  } else {
    initTabs();
  }

  document.addEventListener('shopify:section:load', (event) => initTabs(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-vv-panel]');
    if (!panel) return;
    const section = panel.closest('[data-vv-routine]');
    const tab = section?.querySelector(`[data-vv-tab="${panel.dataset.vvPanel}"]`);
    tab?.click();
  });
})();
